import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {LoaderCircle, Megaphone, LogOut} from "lucide-react";
import {Button, Card} from "@radix-ui/themes";
import {Book} from "../models/Book";
import BookService from "../api/bookService";

export default function RootView() {
    const navigate = useNavigate();
    const [books, setBooks] = useState<Book[] | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [searchValue, setSearchValue] = useState("");
    const [userEmail, setUserEmail] = useState<string | null>(null);
    const bookService = new BookService();

    const fetchBooks = async (title?: string) => {
        try {
            const result = await bookService.getBooks(title);
            setBooks(result.content);
        } catch (fetchError: any) {
            setError(fetchError.message);
        }
        setLoading(false);
    }

    const logout = () => {
        localStorage.removeItem("authToken");
        navigate("/login");
    }

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            navigate("/landing");
        } else {
            setUserEmail("usuario@exemplo.com");
        }
    }, [navigate]);

    useEffect(() => {
        setLoading(true)
        fetchBooks();
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 6,
            slidesToSlide: 3 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3,
            slidesToSlide: 2 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 2,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

    const handleClick = (id: number) => {
        navigate('/book/'+id );
    };

    const searchCleanup = () =>{
        setSearchValue('');
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setBooks(books);
        }, 1000);
    }

    const search = async (search: string) => {
        setSearchValue(search);
        setLoading(true);
        await fetchBooks(search)
    };

    return (
        <div className="p-8">
            <div className="bg-[#2294ae] text-white px-6 py-4 shadow-md flex items-center justify-between mb-6 rounded shadow-md">
                <div className="flex items-center space-x-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-white text-[#2294ae] rounded-full font-bold text-lg">
                        U
                    </div>
                    <div className="text-sm md:text-base font-medium">
                        Bem vindo, {localStorage.getItem('email') || "Carregando..."}
                    </div>
                </div>
                <button onClick={logout} className="bg-slate-200 hover:bg-slate-400 text-neutral-900 py-2 px-4 rounded-md text-xs md:text-base font-medium transition duration-300">
                    <LogOut />
                </button>
            </div>

            <div className={'h-screen align-middle'}>
                <div className={'w-1/4 ml-2'}>
                    <label htmlFor="search"
                           className="block mb-2 text-lg font-medium text-[#2294ae] dark:text-white">
                        BUSCAR
                    </label>
                    <input type="text" value={searchValue} onChange={(e) => search(e.target.value)} id="search"
                           className="shadow-md bg-gray-50 border border-gray-300 rounded-md text-gray-900 text-sm focus:ring-sky-400 focus:border-sky-400 block w-full p-2.5"
                           placeholder="Digite o Título, autor ou ISBN" required/>
                </div>
                {loading ?
                    <div className={'flex justify-center text-center'}>
                        <LoaderCircle className={'animate-spin mt-[180px]'} color="white" size={100} />
                    </div>
                : undefined}
                {!loading && books !== null && books.length === 0 &&
                    <div className={'flex justify-center text-center'}>
                        <Card className={'bg-white w-1/2 rounded-lg shadow-md text-center justify-center mt-[180px]'}>
                           <div className={'flex flex-wrap'}>
                               <div className={'flex-initial'}>
                                    <Megaphone color="#2294ae" size={42} />
                               </div>
                               <div className={'flex-initial'}>
                                <p className={'text-lg mt-2 px-2'}>Ops! Ainda não temos esse livro em nossa biblioteca. Deseja solicitar a inclusão?</p>
                               </div>
                           </div>
                            <div className={'flex gap-2 pt-4 pb-2'}>
                            <Button color={'gray'} onClick={() => searchCleanup()} variant={'solid'}>Cancelar</Button>
                            <Button color={'green'} onClick={() => searchCleanup()} variant={'solid'}>Solicitar</Button>
                            </div>
                        </Card>
                    </div>
                }
                {!loading && books && books.length > 0 ? <Carousel
                    swipeable={true}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    ssr={false} // means to render carousel on server-side.
                    infinite={true}
                    autoPlaySpeed={1000}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container h-[500px] mt-4 "
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    itemClass="hover:mx-4 hover:transition delay-50 duration-50 ease-in-out hover:scale-110"
                >
                    {books && books.map((book, i) => {
                        return (<Card className={'bg-white p-2 m-2 rounded-md shadow-xl cursor-pointer'} onClick={() => handleClick(book.bookId)} >
                            <img src={book.coverUrl} className={'w-full'} style={{ height: 300}}/>
                            <div className={'h-[65px]'}>
                                <div className={'font-semibold mt-2'}> {book.title}</div>
                                <div className={'text-sm'}> {book.authors}</div>
                            </div>
                            {/*<div className={'flex flex-column gap-2 py-2 mt-2'}>*/}
                            {/*    {book.categories.map((category, i) => {*/}
                            {/*        // Return the element. Also pass key*/}
                            {/*        return (<div className={'bg-sky-400 rounded-md p-2 text-sm text-white'}>{category}</div>)*/}
                            {/*    })}*/}
                            {/*</div>*/}

                        </Card>);
                    })}
                </Carousel> : undefined}

            </div>
        </div>
    );
}
